module.exports = __webpack_public_path__ + "img/ecstatic.ac442c2b.png";